import {makeAutoObservable} from "mobx";

export default class ApartmentChatStore {
    constructor() {
        this._sessions = [];
        this._currentChat = null;
        this._messages = [];
        this._isLoading = false;

        makeAutoObservable(this);
    }

    // -------- setters --------

    setSessions(sessions) {
        this._sessions = Array.isArray(sessions) ? sessions : [];
    }

    setCurrentChat(chat) {
        this._currentChat = chat || null;
    }

    setMessages(messages) {
        this._messages = Array.isArray(messages) ? messages : [];
    }

    setIsLoading(value) {
        this._isLoading = Boolean(value);
    }

    addMessage(message) {
        if (!message?.id) return;

        const exists = this._messages.some(
            item => String(item.id) === String(message.id)
        );

        if (exists) return;

        this._messages.push(message);
    }

    upsertSession(newSessionData) {
        if (!newSessionData?.id) return false;

        const index = this._sessions.findIndex(
            item => String(item.id) === String(newSessionData.id)
        );

        if (index > -1) {
            const oldSession = this._sessions[index];

            const updatedSession = {
                ...oldSession,
                ...newSessionData,
                userAvatarUrl: newSessionData.userAvatarUrl || oldSession.userAvatarUrl,
                add: newSessionData.add || oldSession.add || {}
            };

            this._sessions.splice(index, 1);
            this._sessions.unshift(updatedSession);

            return true;
        }

        const draftSession = {
            id: newSessionData.id,
            ...newSessionData,
            userAvatarUrl: newSessionData.userAvatarUrl || null,
            add: newSessionData.add || {
                title: "Новое обращение",
                address: ""
            }
        };

        this._sessions.unshift(draftSession);

        return true;
    }

    bumpSessionToTop(chatId) {
        const index = this._sessions.findIndex(
            item => String(item.id) === String(chatId)
        );

        if (index <= 0) return false;

        const [session] = this._sessions.splice(index, 1);
        this._sessions.unshift(session);

        return true;
    }

    clearUnread(chatId) {
        const session = this._sessions.find(
            item => String(item.id) === String(chatId)
        );

        if (session) {
            session.unreadCount = 0;
        }

        if (
            this._currentChat &&
            String(this._currentChat.id) === String(chatId)
        ) {
            this._currentChat = {
                ...this._currentChat,
                unreadCount: 0
            };
        }
    }

    markAllOwnMessagesAsRead() {
        this._messages.forEach(message => {
            if (message.isOwnMessage) {
                message.isRead = true;
            }
        });
    }

    clearStore() {
        this._sessions = [];
        this._currentChat = null;
        this._messages = [];
        this._isLoading = false;
    }

    prependMessages(messages) {
        if (!Array.isArray(messages) || messages.length === 0) return;

        const existingIds = new Set(
            this._messages.map(item => String(item.id))
        );

        const uniqueMessages = messages.filter(
            item => item?.id && !existingIds.has(String(item.id))
        );

        if (uniqueMessages.length === 0) return;

        this._messages = [
            ...uniqueMessages,
            ...this._messages
        ];
    }

    // -------- getters --------

    get sessions() {
        return this._sessions;
    }

    get currentChat() {
        return this._currentChat;
    }

    get messages() {
        return this._messages;
    }

    get isLoading() {
        return this._isLoading;
    }

    get unreadChatsCount() {
        return this._sessions.filter(
            session => Number(session.unreadCount || 0) > 0
        ).length;
    }

    get totalUnreadCount() {
        return this._sessions.reduce((total, session) => {
            return total + Number(session.unreadCount || 0);
        }, 0);
    }
}